// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__A5MuU","title":"InfoRow_title__1Zby1"};